var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, createElement } from "react";
import styles from "./PaneSelector.module.scss";
import HoverableCircle from "../HoverableCircle";
import UpCaret from "../../icons/CaretUpBig";
import DownCaret from "../../icons/CaretDownBig";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
var Selectors = function (_a) {
    var rows = _a.rows, setExpansion = _a.setExpansion, expansion = _a.expansion;
    return (_jsx("div", __assign({ className: styles.selectors }, { children: rows.map(function (row) { return (_jsx(Selector, { row: row, expansion: expansion, setExpansion: setExpansion }, row.root.key)); }) })));
};
export var Carets = function (_a) {
    var isUp = _a.isUp, sx = _a.sx;
    return (_jsx("div", __assign({ className: styles.carrot }, { children: _jsx(HoverableCircle, __assign({ sx: sx }, { children: isUp ? _jsx(UpCaret, {}) : _jsx(DownCaret, {}) })) })));
};
var Selector = function (_a) {
    var row = _a.row, setExpansion = _a.setExpansion, expansion = _a.expansion;
    var expanded = expansion.root === row.root.key;
    var selected = expanded && expansion.inner !== undefined;
    return (_jsxs("div", __assign({ className: [
            styles.selector,
            selected ? styles.selected : "",
            expanded ? "" : styles.collapsed,
        ].join(" ") }, { children: [_jsxs("div", __assign({ className: styles.innerSelector }, getAutomationTag(TestTag.PaneSelectorItem, row.root.key), { onClick: function () {
                    setExpansion(row.root.key === expansion.root ? {} : { root: row.root.key });
                } }, { children: [_jsx("div", __assign({ className: styles.rootLabel }, { children: row.root.label })), _jsx(Carets, { isUp: expanded })] })), row.nested.map(function (nested) {
                var nestedSelected = expansion.inner === nested.key && expanded;
                var className = nestedSelected
                    ? styles.nestedSelectionCell
                    : styles.nestedCell;
                return (_jsx("div", __assign({ className: styles.nestedSet }, { children: _jsx("div", __assign({ className: className }, getAutomationTag(TestTag.PaneSelectorNestedItem, "".concat(row.root.key, "-").concat(nested.key)), { onClick: function () {
                            setExpansion(expansion.inner === nested.key
                                ? {
                                    root: row.root.key,
                                }
                                : {
                                    root: row.root.key,
                                    inner: nested.key,
                                });
                        } }, { children: nested.label }), nested.key) }), nested.key));
            })] })));
};
var WhiteSpace = function (_a) {
    var expansion = _a.expansion, rows = _a.rows;
    if (!expansion.inner) {
        return null;
    }
    var root = rows.findIndex(function (r) { return r.root.key === expansion.root; });
    var nested = rows[root].nested.findIndex(function (n) { return n.key === expansion.inner; });
    var top = (1 + nested) * 58 + root * 58 + root * 10 + 1;
    var bottomNodes = expansion.root === rows[rows.length - 1].root.key &&
        expansion.inner ===
            rows[rows.length - 1].nested[rows[rows.length - 1].nested.length - 1]
                .key ? (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.bottomWhitespace, style: { top: top + 47 } }), _jsx("div", { className: styles.bottomBorder, style: { top: top + 57 } })] })) : null;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.whiteSpace, style: { top: top } }), bottomNodes] }));
};
export var PaneSelector = function (_a) {
    var rows = _a.rows, pane = _a.pane;
    var _b = useState({}), expansion = _b[0], setExpansion = _b[1];
    return (_jsxs("div", __assign({ className: styles.paneSelector }, { children: [_jsx(Selectors, { setExpansion: setExpansion, expansion: expansion, rows: rows }), _jsx(WhiteSpace, { expansion: expansion, rows: rows }), _jsx("div", __assign({ className: styles.pane }, { children: createElement(pane, { root: expansion.root, inner: expansion.inner }) }))] })));
};
